
const { ccclass, property } = cc._decorator;

@ccclass('SlotIcons')
class SlotIcons {
    @property(cc.String)
    iconKey: string = "";
    @property(cc.SpriteFrame)
    iconRes: cc.SpriteFrame = null;
}

@ccclass
export class SpriteHolderSlot extends cc.Component {
    @property(SlotIcons)
    icons: SlotIcons[] = [];

    private getSpriteFrameByName(key: string) {
        for (let idx = 0; idx < this.icons.length; idx++) {
            let iconFrame = this.icons[idx];
            if (iconFrame.iconKey == key) {
                return iconFrame.iconRes;
            }
        }
        return null;
    }

    setSprite(sprite: cc.Sprite, key: string) {
        let frame = this.getSpriteFrameByName(key);
        if (frame) {
            sprite.spriteFrame = frame
            return true
        } else {
            return false
        }
    }

}
